import React from 'react';
export const BannerServiceOverview = ({ t, cookieTypesUsed, compact = false }) => {
    if (compact) {
        return (React.createElement(React.Fragment, null, t.home.bodyCompactLead));
    }
    return (React.createElement(React.Fragment, null,
        t.home.bodyLead,
        React.createElement("ul", { className: "biskoui-cookie-banner-cookie-types" },
            React.createElement("li", null,
                React.createElement("span", { className: "biskoui-cookie-banner-cookie-type" },
                    " ",
                    t.home.cookiesNecessary,
                    React.createElement("div", { className: "biskoui-tooltip" },
                        React.createElement("span", { className: "biskoui-tooltip-questionmark" }, "?"),
                        React.createElement("div", { className: "biskoui-tooltiptext" }, t.home.cookiesNecessaryTooltip)))),
            cookieTypesUsed.includes("statistics") && (React.createElement("li", null,
                React.createElement("span", { className: "biskoui-cookie-banner-cookie-type" },
                    " ",
                    t.home.cookiesStatistics,
                    React.createElement("div", { className: "biskoui-tooltip" },
                        React.createElement("span", { className: "biskoui-tooltip-questionmark" }, "?"),
                        React.createElement("div", { className: "biskoui-tooltiptext" }, t.home.cookiesStatisticsTooltip))))),
            cookieTypesUsed.includes("preferences") && (React.createElement("li", null,
                React.createElement("span", { className: "biskoui-cookie-banner-cookie-type" },
                    " ",
                    t.home.cookiesPreferences,
                    React.createElement("div", { className: "biskoui-tooltip" },
                        React.createElement("span", { className: "biskoui-tooltip-questionmark" }, "?"),
                        React.createElement("div", { className: "biskoui-tooltiptext" }, t.home.cookiesPreferenceseTooltip))))),
            cookieTypesUsed.includes("marketing") && (React.createElement("li", null,
                React.createElement("span", { className: "biskoui-cookie-banner-cookie-type" },
                    " ",
                    t.home.cookiesMarketing,
                    React.createElement("div", { className: "biskoui-tooltip" },
                        React.createElement("span", { className: "biskoui-tooltip-questionmark" }, "?"),
                        React.createElement("div", { className: "biskoui-tooltiptext" }, t.home.cookiesMarketingTooltip))))))));
};
//# sourceMappingURL=BannerServiceOverview.js.map